import { Menu, ArrowBack } from '@mui/icons-material';
import { useState } from 'react';
import { useAppSelector } from '../../reducers/hooks';
import './Header.css';
import logo from '../../images/logo.png';

function Header({step, dispatchStep, toolType, sidebarOpen, setSidebarOpen} : {step: number, dispatchStep: any, toolType: string, sidebarOpen: boolean, setSidebarOpen: any}) {
    const [infoToggled, setInfoToggled] = useState(false);
    const material = useAppSelector((state) => state.material);
    
    const handleStepMove = () => {
        // Reset prompt if anything is saved
        if (step === 1 && material.name && !window.confirm('Going back here will reset your selections. Are you sure?\nYou can\'t undo this.')) {
            return;
        }
        if (step === 0) {
            window.location.href = 'https://www.garrtool.com/';
            return;
        }
        dispatchStep('-');
    }

    return (
        <header>
            <div className="btnrow">
                <div className="btn backBtn" onClick={handleStepMove}>
                    <ArrowBack />
                    <span>Back</span>
                </div>
                <div className="btn infoBtn" onClick={() => setSidebarOpen(!sidebarOpen)}>
                    <Menu />
                    <span>History</span>
                </div>
            </div>
            <div className="brandTitle">
                <a href="https://www.garrtool.com/">
                    <img src={logo} className='brandImg' alt="logo" />
                </a>
                <h2>Technical Advisor</h2>
            </div>
            <div className="tabs">
                {step === 1 && <div className="tab active">Materials</div>}
                {step === 2 && <div className="tab active">Machining</div>}
                {step >= 3 && <div className="tab active">{toolType === 'endmills' ? 'Endmills' : 'Drills'}</div>}
            </div>
            
        </header>
    )
}

export default Header;